import { useEffect, useMemo, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  Box,
  Button,
  Icon,
  Modal,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { InquiryService } from "service/inquiry/service";
import MDButton from "components/MDButton";

const getTodayDate = (daysOffset = 0) => {
  const today = new Date();
  today.setDate(today.getDate() + daysOffset);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

function InquiryList(): JSX.Element {
  const [row, setRow] = useState<any>([]);
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [open2, setOpen2] = useState(false);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(getTodayDate());
  const [sortType, setSortType] = useState("CD");
  const [processType, setProcessType] = useState("A");
  const [answerModalOpen, setAnswerModalOpen] = useState(false);
  const [answer, setAnswer] = useState(null);
  const [inquiryId, setInquiryId] = useState(null);

  const limit = 10;

  const list = async (
    processType: string,
    sort: string,
    search: string,
    startDate: string,
    endDate: string,
    limit: number,
    page: number
  ) => {
    try {
      const processYN = processType === "A" ? "" : processType;
      const res = await InquiryService.list2(
        processYN,
        sort,
        search,
        startDate,
        endDate,
        limit,
        page
      );

      console.log(res);
      setTableData(res.list);
      setTotalPages(Math.ceil(res.totalCount / limit));
    } catch (err) {
      console.log(err);
    }
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    list(processType, sortType, search, startDate, endDate, limit, currentPage);
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    list(processType, sortType, search, startDate, endDate, limit, currentPage);
  }, [processType, sortType, startDate, endDate]);

  const csv = async () => {
    try {
      const processYN = processType === "A" ? "" : processType;
      const a = document.createElement("a");
      a.href = `${process.env.REACT_APP_HOST}admin/csv2?startDate=${startDate}&endDate=${endDate}&processYN=${processYN}&search=${search}&sort=${sortType}`;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <DashboardLayout>
      {open2 &&
        modal(
          open2,
          setOpen2,
          row,
          () => list(processType, sortType, search, startDate, endDate, limit, currentPage),
          setAnswerModalOpen,
          setInquiryId,
          setAnswer
        )}
      {answerModalOpen && (
        <AnswerModal
          open={answerModalOpen}
          onClose={() => setAnswerModalOpen(false)}
          inquiryId={inquiryId}
          answer={answer}
          setAnswer={setAnswer}
          setOpen2={setOpen2}
          refreshList={() =>
            list(processType, sortType, search, startDate, endDate, limit, currentPage)
          }
        />
      )}
      <DashboardNavbar />
      <MDBox my={3}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            gap: "16px",
            padding: "0 8px",
          }}
        >
          <div
            style={{
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "white",
              display: "flex",
              gap: "8px",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid black",
              cursor: "pointer",
            }}
            onClick={csv}
            role="button"
          >
            <Icon>description</Icon>
            CSV 다운로드
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                검색어
              </span>
              <input
                type="text"
                placeholder="성명, 이메일, 문의내용"
                style={{ padding: "8px" }}
                onChange={(e: any) => setSearch(e.target.value)}
              />
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "rgb(30, 155, 107)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "white",
                  borderRadius: "8px",
                  width: "50px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCurrentPage(1);
                  list(processType, sortType, search, startDate, endDate, limit, currentPage);
                }}
              >
                검색
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                처리여부
              </span>
              <select
                name=""
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setProcessType(e.target.value)}
              >
                {processData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                정렬 기준
              </span>
              <select
                name=""
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setSortType(e.target.value)}
              >
                {sortData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ gap: "16px", display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  시작일 선택
                </span>
                <input
                  type="date"
                  value={startDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setStartDate(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  종료일 선택
                </span>
                <input
                  type="date"
                  value={endDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <Card style={{ marginTop: "24px" }}>
          <div style={{ padding: "24px 16px" }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ minWidth: "1000px", width: "100%" }}>
                <thead>
                  <tr
                    style={{
                      fontSize: "14px",
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "16px",
                      fontFamily: "Pretendard",
                    }}
                  >
                    <th>No.</th>
                    <th>문의 유형</th>
                    <th>이름</th>
                    <th>아이디</th>
                    <th>이메일</th>
                    <th>문의 내용</th>
                    <th>문의 일자</th>
                    <th>처리 여부</th>
                    <th>상세보기</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((el: any) => (
                    <tr
                      key={el.inquiry_id}
                      style={{
                        fontSize: 12,
                        color: "#000000DE",
                        textAlign: "center",
                        fontFamily: "Pretendard",
                      }}
                    >
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.inquiry_id}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.category}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.name}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.login_type === "C"
                          ? el.user_id
                          : el.login_type === "K"
                          ? "카카오 로그인"
                          : el.login_type === "N"
                          ? "네이버 로그인"
                          : el.login_type === "G"
                          ? "구글 로그인"
                          : "비회원"}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.email}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "200px",
                        }}
                      >
                        {el.content}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.created_at ? String(el.created_at).slice(0, 10) : ""}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.processed_yn}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        <MDButton
                          onClick={() => {
                            setRow(el);
                            setOpen2(true);
                          }}
                        >
                          상세보기
                        </MDButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&.Mui-selected": {
                      backgroundColor: "#1e9b6b",
                      color: "white",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#1e9b6b",
                    },
                  },
                }}
              />
            </div>
          </div>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
export default InquiryList;

function modal(
  open: boolean,
  setOpen: any,
  row: any,
  refreshList: () => void,
  setAnswerModalOpen: any,
  setInquiryId: any,
  setAnswer: any
) {
  const updateState = async () => {
    try {
      await InquiryService.updateState(row.inquiry_id);
      await refreshList();
      setOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "32px",
        width: "100%",
      }}
    >
      <MDBox
        bgColor="white"
        borderRadius="16px"
        position={"relative"}
        sx={{
          maxHeight: "calc(100vh - 64px)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Icon
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            cursor: "pointer",
            fontSize: 28,
            color: "#888",
            zIndex: 2,
          }}
        >
          close
        </Icon>
        <MDBox
          p="50px 40px"
          display="flex"
          flexDirection="column"
          gap="25px"
          sx={{ overflowY: "auto" }}
        >
          <Table sx={{ width: 800, border: "1px solid #0000001A" }} size="small">
            <TableBody>
              {[
                ["문의 유형", row.category, row.withdrawal_reason],
                ["문의 일자", row.created_at],
                ["이름", row.name],
                [
                  "아이디",
                  row.login_type === "C"
                    ? row.user_id
                    : row.login_type === "K"
                    ? "카카오 로그인"
                    : row.login_type === "N"
                    ? "네이버 로그인"
                    : "구글 로그인",
                ],
                ["이메일", row.user_email],
                ["문의 내용", row.content],
              ].map(([label, value, value2], idx) => (
                <TableRow key={idx}>
                  <TableCell
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      border: "1px solid #0000001A",
                      fontFamily: "Pretendard",
                      backgroundColor: "#F5F5F5",
                      minWidth: "150px",
                    }}
                  >
                    {label}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 14,
                      border: "1px solid #0000001A",
                      fontFamily: "Pretendard",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {label === "문의 내용" ? (
                      <MDBox
                        sx={{
                          maxHeight: 200,
                          overflowY: "auto",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {value}
                      </MDBox>
                    ) : (
                      <>
                        {value}
                        <br />
                        {value2 && "탈퇴 사유:" + value2}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {row.images && row.images.length > 0 && (
                <TableRow>
                  <TableCell
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      border: "1px solid #0000001A",
                      fontFamily: "Pretendard",
                      backgroundColor: "#F5F5F5",
                      minWidth: "150px",
                      verticalAlign: "top",
                    }}
                  >
                    첨부 이미지
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 14,
                      border: "1px solid #0000001A",
                      fontFamily: "Pretendard",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                      }}
                    >
                      {row.images.map((img: any, idx: number) => (
                        <a
                          key={idx}
                          href={`${process.env.REACT_APP_HOST}img/${img.image_url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            width: 120,
                            height: 120,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 4,
                            border: "1px solid #ddd",
                            backgroundColor: "#fafafa",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={`${process.env.REACT_APP_HOST}img/${img.image_url}`}
                            alt={`첨부 이미지 ${idx + 1}`}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </a>
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    border: "1px solid #0000001A",
                    fontFamily: "Pretendard",
                    backgroundColor: "#F5F5F5",
                    minWidth: "150px",
                  }}
                >
                  {"처리 여부"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: 14,
                    fontFamily: "Pretendard",
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {row.processed_yn}
                  <Button onClick={updateState}>변경</Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    border: "1px solid #0000001A",
                    fontFamily: "Pretendard",
                    backgroundColor: "#F5F5F5",
                    minWidth: "150px",
                  }}
                >
                  답변
                </TableCell>
                {row.answer && (
                  <TableCell
                    sx={{
                      fontSize: 14,
                      fontFamily: "Pretendard",
                      justifyContent: "space-between",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        maxHeight: 200,
                        overflowY: "auto",
                        marginRight: 1,
                        "& p:empty": { minHeight: "1em" },
                      }}
                      dangerouslySetInnerHTML={{ __html: row.answer }}
                    />
                    <Button
                      onClick={() => {
                        setInquiryId(row.inquiry_id);
                        setAnswer(row.answer);
                        setAnswerModalOpen(true);
                      }}
                    >
                      수정
                    </Button>
                  </TableCell>
                )}
                {!row.answer && (
                  <TableCell
                    sx={{
                      fontSize: 14,
                      fontFamily: "Pretendard",
                      justifyContent: "space-between",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    답변 없음
                    <Button
                      onClick={() => {
                        setInquiryId(row.inquiry_id);
                        setAnswerModalOpen(true);
                      }}
                    >
                      답변 작성
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            </TableBody>
          </Table>
        </MDBox>
      </MDBox>
    </Modal>
  );
}

function AnswerModal({
  open,
  onClose,
  answer,
  inquiryId,
  setAnswer,
  setOpen2,
  refreshList,
}: {
  open: boolean;
  onClose: () => void;
  answer?: string;
  inquiryId: number;
  setAnswer: any;
  setOpen2: any;
  refreshList: any;
}) {
  const [answerText, setAnswerText] = useState(answer || "");
  const quillRef = useRef<ReactQuill>(null);

  const imageHandler = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        const quill = quillRef.current?.getEditor();
        if (quill) {
          const range = quill.getSelection(true);
          quill.insertEmbed(range.index, "image", reader.result);
          quill.setSelection(range.index + 1, 0);
        }
      };
      reader.readAsDataURL(file);
    };
  };

  const uploadBase64Images = async (html: string): Promise<string> => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const images = doc.querySelectorAll('img[src^="data:"]');

    const token = localStorage.getItem("accessToken");

    for (const img of images) {
      const base64 = img.getAttribute("src");
      if (!base64) continue;

      const res = await fetch(base64);
      const blob = await res.blob();
      const formData = new FormData();
      formData.append("image", blob, "image.png");

      const uploadRes = await fetch(`${process.env.REACT_APP_HOST}inquiry/img/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await uploadRes.json();

      if (data.key) {
        img.setAttribute("src", `${process.env.REACT_APP_HOST}img/${data.key}`);
      }
    }

    return doc.body.innerHTML;
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["link", "image"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );

  const handleSave = async () => {
    try {
      const uploadedHtml = await uploadBase64Images(answerText);
      await InquiryService.answer(inquiryId, uploadedHtml);
      setAnswer(uploadedHtml);
    } catch (error) {
      alert("답변 저장에 실패했습니다.");
    }
  };

  useEffect(() => {
    setAnswerText(answer || "");
  }, []);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          minWidth: 600,
          maxWidth: 800,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <h3>답변 작성</h3>
        <Box
          sx={{
            mb: 2,
            "& .ql-container": { minHeight: 200, fontSize: 14 },
            "& .ql-editor": { minHeight: 200 },
          }}
        >
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={answerText}
            onChange={setAnswerText}
            modules={modules}
            placeholder="답변을 입력하세요"
          />
        </Box>
        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
          <Button onClick={onClose}>취소</Button>
          <Button
            onClick={async () => {
              await handleSave();
              alert("답변이 저장되었습니다.");
              await refreshList();
              onClose();
              setOpen2(false);
            }}
          >
            저장
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

const sortData = [
  { label: "최신순", value: "CD" },
  { label: "오래된순", value: "CA" },
];

const processData = [
  { label: "전체", value: "A" },
  { label: "Y", value: "Y" },
  { label: "N", value: "N" },
];
